function PlantKpiPanel({
  ultimoIntervento,
  prossimaManutenzione,
  scadenzeTecniche,
  documentiImpianto,
  sectionTitleStyle,
  getStatusBadge,
}) {
  return (
    <div
      style={{
        border: "1px solid #dbe4f0",
        borderRadius: "12px",
        padding: "16px",
        backgroundColor: "#f8fbff",
      }}
    >
      <h2
        style={{
          ...sectionTitleStyle,
          fontSize: "20px",
        }}
      >
        Stato operativo
      </h2>

      <div
        style={{
          marginTop: "14px",
          lineHeight: "2",
        }}
      >
        <div>
          <strong>Ultimo intervento:</strong>{" "}
          {ultimoIntervento
            ? new Date(
                ultimoIntervento.intervention_date
              ).toLocaleDateString()
            : "—"}
        </div>

        <div>
          <strong>Tipo intervento:</strong>{" "}
          {ultimoIntervento?.intervention_type || "—"}
        </div>

        <div>
          <strong>Tecnico:</strong>{" "}
          {ultimoIntervento?.technician_name || "—"}
        </div>

        <div>
          <strong>Prossima manutenzione:</strong>{" "}
          {prossimaManutenzione
            ? new Date(
                prossimaManutenzione.next_due_date
              ).toLocaleDateString()
            : "—"}
        </div>

        <div>
          <strong>Scadenze aperte:</strong>{" "}
          {scadenzeTecniche.length}
        </div>

        <div>
          <strong>Documenti:</strong>{" "}
          {documentiImpianto.length}
        </div>

        <div style={{ marginTop: "10px" }}>
          {scadenzeTecniche.length > 0
            ? getStatusBadge("Attenzione scadenze")
            : getStatusBadge("Impianto attivo")}
        </div>
      </div>
    </div>
  );
}

export default PlantKpiPanel;